import styled from '@emotion/styled';
import React from 'react';
import { color, space, flexbox, background } from 'styled-system';
import { useWindowSize } from 'react-use';

const Card = styled.div`
  display: flex;
  position: ${props => props.isMobile ? 'fixed' : 'absolute'};
  bottom: 0;
  left: 0;
  right: 0;
  ${color};
  ${space};
  ${flexbox};
  ${background}
`;

const ModalBottom = props => {
  const { width } = useWindowSize();

  return (
    <Card
      bg="white"
      p={2}
      isMobile={width < 768}
      {...props}
    />
  )
};

export default ModalBottom;
